/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoUserLogin } from '../../models/dto-user-login';
import { SessionResponse } from '../../models/session-response';

export interface IdentityControllerLogin$Params {
      body: DtoUserLogin
}

export function identityControllerLogin(http: HttpClient, rootUrl: string, params: IdentityControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: SessionResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: SessionResponse;
      }>;
    })
  );
}

identityControllerLogin.PATH = '/identity/session';
